import { Show } from 'solid-js'
import stampSvg from '~/assets/figma/stamp.svg'
import tickLinearSvg from '~/assets/figma/tick-linear.svg'
import { useLocalizedTreeName } from '~/hooks/use-localized-tree-name'
import type { ShopItem } from '~/lib/derive-shop-catalog'
import { m } from '~/paraglide/messages'

export function ShopItemCard(props: {
  item: ShopItem
  onRedeem: () => void
  onUpgrade: () => void
}) {
  const name = useLocalizedTreeName(() => props.item.treeTypeId)
  const isResolved = () => {
    const key = `tree_type_${props.item.treeTypeId}_title`
    return name() !== key
  }

  const handleClick = () => {
    if (props.item.isOwned) return
    if (props.item.isLocked) {
      props.onUpgrade()
      return
    }
    props.onRedeem()
  }

  return (
    <button
      type="button"
      onClick={handleClick}
      disabled={props.item.isOwned}
      class="flex w-[118px] flex-col items-center gap-[6.779px] overflow-hidden rounded-[20px] border border-white bg-white/35 px-2 pb-2 transition-transform duration-100 active:scale-[0.97] disabled:active:scale-100"
    >
      <img
        src={props.item.asset}
        alt=""
        aria-hidden="true"
        class="size-[92px] object-contain"
      />
      <p
        class="line-clamp-2 h-8 w-full text-center text-[12px] leading-4 text-bakery-brown-soft"
        classList={{ 'text-transparent': !isResolved() }}
      >
        {name()}
      </p>
      <div class="flex items-center justify-center gap-1 rounded-[32px] px-2 py-1">
        <Show
          when={props.item.isOwned}
          fallback={
            <>
              <img src={stampSvg} alt="" aria-hidden="true" class="size-5" />
              <span class="text-[14px] font-bold tabular-nums leading-[18px] text-bakery-gem-text">
                {props.item.price ?? '—'}
              </span>
            </>
          }
        >
          <img src={tickLinearSvg} alt="" aria-hidden="true" class="size-5" />
          <span class="text-[14px] leading-[18px] text-[rgba(1,62,69,0.45)]">
            {m.owned_tag()}
          </span>
        </Show>
      </div>
    </button>
  )
}
